import Axios from 'axios';

const API_URL =  process.env.API_URL + '/api/v1/';

class TestimoniUmum {
  index() {
    return Axios.get(API_URL + 'testimoniumum-list');
  }

  show(testimoniumum) {
    return Axios.get(API_URL + `testimoniumum/${testimoniumum}`);
  }
}

export default new TestimoniUmum();



// WEBPACK FOOTER //
// ./src/api/testimoniumum.js